








import { Component, Vue, Watch } from "vue-property-decorator";
import BarNav from "@/components/BarNav.vue";
import ContainerMain from "@/components/ContainerMain.vue";
import FirebaseWeb from "./firebase";
const firebase = new FirebaseWeb();

@Component({
    components: {
        ContainerMain,
        BarNav
    }
})
export default class App extends Vue {
    mounted() {
        if (!firebase.isAppInitialized) {
            firebase.initializeFirebase();
        }
    }

    @Watch("isBarNav", { immediate: true, deep: true })
    onBarNavChange(val: any, oldVal: any) {
        if (val) {
            firebase.askNotificationPermission();
        }
    }

    get isBarNav() {
        return this.$store.getters.barnav;
    }
}
